// this is an auto generated file. This will be overwritten

export const onCreateSensorAlerts = /* GraphQL */ `
  subscription OnCreateSensorAlerts($user_id: String!) {
    onCreateSensorAlerts(user_id: $user_id) {
      alerts {
        parameters
        sensor_id
        timestamp
        __typename
      }
      timestamp
      user_id
      __typename
    }
  }
`;
export const onCreateSensorReadings = /* GraphQL */ `
  subscription OnCreateSensorReadings($user_id: String!) {
    onCreateSensorReadings(user_id: $user_id) {
      reads {
        parameters
        sensor_id
        timestamp
        __typename
      }
      timestamp
      user_id
      __typename
    }
  }
`;
